import Badge from '@mui/material/Badge';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Badge": Badge, "@mui/material/Stack": Stack, "@mui/material/IconButton": IconButton, "@mui/icons-material/CalendarMonth": CalendarMonthIcon, "@mui/icons-material/FolderOpen": FolderOpenIcon, "@mui/icons-material/ReportProblemOutlined": ReportProblemOutlinedIcon } } });
export default ClientProvider;
